import { NgModule } from '@angular/core';
import { PopupComponent } from './popup.component';

@NgModule({
  imports: [PopupComponent],
  exports: [PopupComponent]
})
export class PopupModule {}
